import styled from "styled-components"

export const Container = styled.div`
    background-color: var(--medGrey);
    display: flex;
`

export const Wrapper = styled.div`
    flex: 1;
`

export const Main = styled.div`
    margin-top: 10px;
    flex: 4;
    color: var(--lightGrey);
    padding: 20px;
`

export const Title = styled.h1`
`

export const StyledForm = styled.form`
    display: flex;
    flex-wrap: wrap;
    background-color: var(--darkGrey);
    padding: 20px;
    margin-top: 20px;
    border-radius: 10px;
    -webkit-box-shadow: 0px 0px 15px -10px rgba(0, 0, 0, 0.9);
    box-shadow: 0px 0px 15px -10px rgba(0, 0, 0, 0.9);
`

export const FormItem = styled.div`
    width: 400px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    margin-bottom: 15px;
    margin-right: 20px;
`

export const StyledLabel = styled.label`
    margin-bottom: 5px;
    font-size: var(--fontS);
    font-weight: 600;
`

export const StyledInput = styled.input`
    color-scheme: dark;
    background-color: var(--darkGrey);
    color: var(--lightGrey);
    border: none;
    border-bottom: 1px solid var(--primary);
    height: 30px;

    :focus{
        border-bottom: 1px solid var(--secondary);
        outline: none;
    }
`

export const RadioWrapper = styled.div`
    display: flex;
    align-items: center;
`

export const RadioLabel = styled.label`
    margin: 10px;
`

export const StyledSelect = styled.select`
    color-scheme: dark;
    height: 30px;
    border-radius: 5px;
`

export const StyledOption = styled.option`
`

export const StyledButton = styled.button`
    width: 200px;
    height: 50px;
    border: none;
    padding: 5px;
    margin-top: 10px;
    background-color: var(--primary);
    border-radius: 10px;
    color: var(--white);
    font-size: var(--fontM);
    cursor: pointer;
`

export const Upload = styled.div`
    margin-top: 10px;
    display: flex;
    align-items: center;
`

export const CreateImage = styled.img`
    width: 80px;
    height: 80px;
    border-radius: 10px;
    object-fit: cover;
    margin-right: 20px;
    background-color: var(--medGrey);
`

export const UploadIcon = styled.div`
    cursor: pointer;
    color: var(--secondary);
`

export const ButtonContainer = styled.div`
    width: 100%;
    display: flex;
    justify-content: center;
`

export const ButtonWrapper = styled.div`
    margin: 20px;
    padding: 20px;
    border-radius: 10px;
    -webkit-box-shadow: 0px 0px 15px -10px rgba(0, 0, 0, 0.9);
    box-shadow: 0px 0px 15px -10px rgba(0, 0, 0, 0.9);
    background-color: var(--darkGrey);
    color: var(--lightGrey);
    width: 300px;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
`

export const Message = styled.div`
    margin-top: 20px;
    color: var(--secondary);
`